import React from "react";

export default function Terms() {
  return (
    <>
      <div>
        <div style={{ textAlign: "center", paddingLeft: "50px", paddingRight: "50px" }} >
          <div style={{ paddingTop: "56px" }} ></div>

          <text style={{ fontSize: "20px", fontWeight: "700", textAlign: "center" }} >Términos y Condiciones de Uso</text>

          <div style={{ margin: "auto", marginTop: "24px", marginBottom: "20px", textAlign: "left" }} >
            <text style={{ fontSize: "16px" }} >
              Bienvenido a la aplicación móvil de acceso del Gimnasio Kochul Gym. Esta aplicación es propiedad de Kochul Gym.
              Al descargar, instalar o utilizar esta aplicación, aceptas estos Términos y Condiciones de Uso ("Términos").
              Si no estás de acuerdo con estos Términos, no debes utilizar la aplicación.
            </text>

            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "18px" }} >
                1. Acceso a la Aplicación
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <text style={{ fontSize: "16px" }} >
                El uso de la aplicación está disponible para los miembros activos del Gimnasio Kochul Gym y se concede acceso sólo
                con fines de uso personal y no comercial. Al utilizar la aplicación, reconoces y aceptas que eres el único responsable
                de mantener la confidencialidad de tu información de acceso y que no compartirás dicha información con terceros.
              </text>
            </div>


            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "18px" }} >
                2. Responsabilidades del Usuario
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <text style={{ fontSize: "16px" }} >
                Al utilizar esta aplicación, te comprometes a hacerlo de manera responsable y en cumplimiento con todas las leyes y
                regulaciones aplicables. En particular, te comprometes a no utilizar la aplicación para:
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <p style={{ fontSize: "16px" }} >
                - Publicar, transmitir, distribuir o almacenar contenido que pueda violar los derechos de terceros o que pueda ser
                ofensivo, ilegal o perjudicial.
              </p>
              <p style={{ fontSize: "16px" }} >
                - Modificar o intentar modificar la aplicación o su contenido.
              </p>
              <p style={{ fontSize: "16px" }} >
                - Utilizar la aplicación de manera fraudulenta o para acceder a información de otros usuarios sin autorización.
              </p>
            </div>

            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "18px" }} >
                3. Propiedad Intelectual
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <text style={{ fontSize: "16px" }} >
                Todos los derechos de propiedad intelectual de la aplicación y su contenido son propiedad de Kochul Gym o de terceros
                que han otorgado licencias para su uso. No se te concede ningún derecho de propiedad intelectual sobre la aplicación
                o su contenido.
              </text>
            </div>

            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "18px" }} >
                4. Limitación de Responsabilidad
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <text style={{ fontSize: "16px" }} >
                En ningún caso Kochul Gym será responsable por daños directos, indirectos, incidentales, especiales, consecuentes,
                punitivos o de cualquier otra índole, incluyendo, sin limitación, la pérdida de beneficios, interrupción del negocio,
                pérdida de información o cualquier otro tipo de pérdida o daño que surja o esté relacionado con el uso o imposibilidad
                de uso de la aplicación, incluso si se ha advertido de la posibilidad de dichos daños.
              </text>
            </div>

            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "18px" }} >
                5. Modificaciones de los Términos
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <text style={{ fontSize: "16px" }} >
                Nos reservamos el derecho de modificar estos Términos en cualquier momento. Los cambios entrarán en vigor inmediatamente
                después de su publicación en la aplicación. El uso continuado de la aplicación después de dichas modificaciones constituirá
                tu aceptación de los nuevos Términos.
              </text>
            </div>

            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "18px" }} >
                6. Terminación del Acceso
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <text style={{ fontSize: "16px" }} >
                Nos reservamos el derecho de rescindir o suspender tu acceso a la aplicación en cualquier momento y sin previo aviso si
                consideramos que has violado estos Términos o cualquier otra ley o regulación aplicable.
              </text>
            </div>

            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "18px" }} >
                7. Ley Aplicable
              </text>
            </div>

            <div style={{ marginLeft: "24px", marginRight: "24px" }}>
              <text style={{ fontSize: "16px" }} >
                Estos Términos y Condiciones de Uso se regirán e interpretarán de acuerdo con las leyes del país donde se encuentra el
                Gimnasio Kochul Gym y cualquier controversia que surja en relación con estos Términos se someterá a los tribunales
                competentes de dicha jurisdicción.
              </text>
            </div>


            <div style={{ marginTop: "24px" }} >
              <text style={{ fontSize: "16px" }} >
                Si tienes alguna pregunta o comentario sobre estos Términos contáctanos.
              </text>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
